import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import client from "../lib/api";
import Footer from "../components/Footer";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await client.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível processar o pedido.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#0C0E12]" data-testid="forgot-password-page">
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 justify-center mb-10">
            <Heart className="w-5 h-5 text-[#C5A880]" />
            <span className="font-display text-2xl">Soulmatch</span>
          </Link>

          <div className="bg-[#161920] border border-white/5 rounded-2xl p-10">
            {done ? (
              <div className="text-center" data-testid="forgot-password-sent">
                <CheckCircle2 className="w-12 h-12 text-[#C5A880] mx-auto mb-4" />
                <h1 className="font-display text-2xl mb-3">Verifica o teu email</h1>
                <p className="text-[#DCD7D2] text-sm leading-relaxed mb-6">
                  Se este email estiver associado a uma conta Soulmatch, recebes em poucos
                  minutos um link para definires uma nova palavra-passe. O link é válido durante
                  <strong className="text-[#C5A880]"> 30 minutos</strong>.
                </p>
                <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#C5A880] hover:underline">
                  <ArrowLeft className="w-4 h-4" /> Voltar a entrar
                </Link>
              </div>
            ) : (
              <>
                <span className="label-uppercase">Recuperar acesso</span>
                <h1 className="font-display text-3xl mt-3 mb-3">Esqueceste-te da palavra-passe?</h1>
                <p className="text-[#A29F9B] text-sm mb-8 leading-relaxed">
                  Indica o email da tua conta. Enviamos-te um link seguro para escolheres
                  uma nova palavra-passe.
                </p>

                <form onSubmit={submit} className="space-y-6">
                  <div>
                    <label className="text-xs text-[#A29F9B]">Email</label>
                    <input
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="input-elegant"
                      placeholder="o-teu-email@exemplo.pt"
                      data-testid="forgot-email"
                      autoFocus
                    />
                  </div>
                  <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="forgot-submit">
                    {busy ? "A enviar..." : "Enviar link de recuperação"}
                  </button>
                </form>

                <p className="text-sm text-[#A29F9B] mt-6 text-center">
                  Lembraste-te?{" "}
                  <Link to="/login" className="text-[#C5A880] hover:underline" data-testid="forgot-go-login">
                    Voltar
                  </Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
